import React from 'react';
import {observer} from 'mobx-react';
import {TechseeBaseComponent} from '@techsee/techsee-ui-common/lib/_shared/techsee-base-component';
import {ISearchTagsController} from './SearchTags.contracts';
import classNames from 'classnames';
import './SearchTags.scss';

interface ISearchTagsProps {
    ctrl: ISearchTagsController;
}

@observer
export class SearchTags extends TechseeBaseComponent<ISearchTagsProps> {
    handleSubmit = (e: React.FormEvent): void => {
        e.preventDefault();
        this.props.ctrl.onSubmit();
    };

    handleChange = (e: React.ChangeEvent<HTMLInputElement>): void => {
        const value = e.target.value;
        this.props.ctrl.onSearchTermChange(value);
    };

    handleIconClick = (): void => {
        this.props.ctrl.onSubmit();
    };

    renderInternal(): JSX.Element {
        const {ctrl} = this.props;

        // Don't render if shouldShow is false
        if (!ctrl.shouldShow) {
            return <></>;
        }

        const {translate, useNewInterface, requireImage} = ctrl;

        // Determine validation state for highlight-control replacement
        const isValid = ctrl.searchTerm && ctrl.searchTerm.trim().length > 0;
        const showError = ctrl.isEmpty || (ctrl.isSubmitted && !isValid);
        const showSuccess = isValid && ctrl.isDirty && !ctrl.isSubmitted;

        const formGroupClasses = classNames('form-group', {
            'has-error': showError,
            'has-success': showSuccess
        });

        const inputClasses = classNames('btn', 'tag-search', 'form-control', {
            'empty-submit': ctrl.isEmpty
        });

        const showNoResults = ctrl.isSubmitted && ctrl.searchTerm && !ctrl.hasResults;

        return (
            <form onSubmit={this.handleSubmit} className='dashboard-search-tags-container' noValidate>
                <div className={formGroupClasses}>
                    <input
                        type='text'
                        name='search-tag-input'
                        placeholder={translate('MAIN.VIEW.TAG_SEARCH')}
                        value={ctrl.searchTerm}
                        onChange={this.handleChange}
                        className={inputClasses}
                        required
                    />
                    {!useNewInterface && (
                        <i className='glyphicon glyphicon-search tag-search-icon' onClick={this.handleIconClick} />
                    )}
                    {useNewInterface && (
                        <img
                            className='side-bar-icon tag-search-icon'
                            src={requireImage('search-by-tag.png', useNewInterface)}
                            onClick={this.handleIconClick}
                            alt='Search'
                        />
                    )}
                </div>
            </form>
        );
    }
}
